<template>
  <div
    class="file-container border-2 hover:border-brand mr-4 w-48 h-64 max-w-xs relative flex-shrink-0 mb-4 overflow-hidden"
    :class="{ 'border-brand': checked }"
    @click.stop="selectCheckbox"
  >
    <div class="border m-2 relative">
      <img
        :src="file.thumbnail_url"
        :alt="file.filename"
        class="w-full object-contain"
        @error="useDefaultThumbnail"
      />
    </div>
    <div
      class="absolute bottom-0 w-full p-2 border-t flex justify-between" style="min-height: 4.5rem"
      :class="{ 'bg-brand': checked, 'bg-blue-lightest': !checked }"
    >
      <p
        class="break-words font-medium text-left text-xs w-4/5"
        :class="{ 'text-white': checked, 'text-black': !checked }"
      >
        {{ file.filename }}
      </p>
        <button
          @click.stop="openFile(file)"
          class="text-xs outline-none focus:outline-none block"
        >
          <i
            class="fas fa-external-link-alt"
            :class="{ 'text-white': checked }"
          ></i>
        </button>
    </div>
    <div class="checkbox absolute inset-x-0 top-0 flex justify-start">
      <button
        class="py-1 px-2 rounded-full shadow hover:bg-brand mt-2 ml-2"
        :class="{ 'bg-brand': checked, 'bg-white': !checked }"
        @click.stop="selectCheckbox"
      >
        <i class="fa fa-check text-white"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectVaultFile",
  props: ["file"],
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    useDefaultThumbnail(event) {
      const fallback = "/images/default-thumbnail.png";
      if (!event.target.src.endsWith(fallback)) {
        event.target.src = fallback;
      }
    },

    openFile(file) {
      if (file.is_filed) {
        window.open(
          `/#/vault-documents/${this.$route.params.vault_id}/search?file=${file.id}`,
          "_blank"
        );
      } else {
        window.open(
          `/#/vaults/${this.$route.params.vault_id}/manage/tagging?file=${file.id}`,
          "_blank"
        );
      }
    },
    selectCheckbox() {
      this.checked = !this.checked;

      this.$emit("file-checked", {
        checked: this.checked,
        file: this.file,
      });
    },
  },
};
</script>

<style scoped>
.file-container:last-child {
  margin-right: 0;
}
</style>
